let menus = [
  {
    name: "首页",
    path: "/",
    paths: ["/"],
    icon: "&#xe6b7;",
    children: [],
  },
  {
    name: "保函申请",
    path: "/apply/index",
    paths: ["/apply/index"],
    // "/projectList/bidSecurity", "/apply/contract", "/apply/peasant", "/apply/contract", "/apply/contract", "/apply/contract"
    icon: "&#xe6ba;",
    children: [],
  },
  {
    name: "保函订单",
    path: ['fzb'].indexOf(process.config.city) > -1 ? "/order/lawsuit/list" : "/order/index",
    paths: ["/order/index", "/order/bidSecurity/list", ""],
    icon: "&#xe6b9;",
    children: [],
  },
  {
    name: "贷款申请",
    path: "/loan/apply",
    paths: ["/loan/apply"],
    icon: "&#xe6b5;",
    children: [],
  },
  {
    name: "贷款订单",
    path: "/loan/order",
    paths: ["/loan/order"],
    icon: "&#xe6bb;",
    children: [],
  },
  {
    name: "票据贴现",
    path: "/bill/index",
    paths: ["/bill/index"],
    icon: "&#xe6bc;",
    children: [],
  },
  {
    name: "贴现订单",
    path: "/billOrder/list",
    icon: "&#xe6b4;",
    paths: ["/billOrder/list", "/billOrder/businessList"],
    opened: false,
    children: [
      {
        name: "银票贴现订单",
        path: "/billOrder/list",
      },
      {
        name: "商票贴现订单",
        path: "/billOrder/businessList",
      },
    ],
  },
  {
    name: "我的发票",
    path: "/invoice/list",
    icon: "&#xe6b6;",
    paths: ["/invoice/list"],
    children: [],
  },
  {
    name: "用户中心",
    path: "/user/account/info",
    icon: "&#xe6b8;",
    paths: ["/user/account/info", "/user/company/info", "/user/qualifications/list", "/user/ca"],
    opened: false,
    children: [
      {
        name: "账户信息",
        path: "/user/account/info",
      },
      {
        name: "企业信息",
        path: "/user/company/info",
      },
      {
        name: "企业资质",
        path: "/user/qualifications/list",
      },
      {
        name: "CA证书",
        path: "/user/ca",
      },
    ],
  },
  {
    name: "优惠券中心",
    path: "/coupon/index",
    icon: "&#xe78e;",
    paths: ["/coupon/index"],
    children: [],
  },
  {
    name: "积分活动",
    path: "/points/index",
    icon: "&#xe6dc;",
    paths: ["/points/index"],
    children: [],
  },
  {
    name: "纸质保函记录",
    path: "/paperGuarantee/index",
    icon: "&#xe611;",
    paths: ["/paperGuarantee/index"],
    children: [],
  },
  {
    name: "文书生成",
    path: "/documents/index",
    icon: "&#xe61c;",
    paths: ["/documents/index"],
    children: [],
  },
];

export function filterNestedMenuItems(menuItems, predicate) {
  // 递归过滤嵌套菜单项
  return menuItems.filter((menuItem) => {
    // 对当前菜单项执行条件判断
    let match = predicate(menuItem);
    // 如果菜单项有子菜单，递归过滤子菜单
    if (menuItem.children) {
      menuItem.children = filterNestedMenuItems(menuItem.children, predicate);
    }
    // 返回满足条件或者有子菜单的菜单项
    return match || (menuItem.children && menuItem.children.length > 0);
  });
}

console.log("process.config.routet", process.config.routet);

let routes = process.config.routet;
if (routes) {
  routes = routes.split(",");
}
let filteredMenu = filterNestedMenuItems(menus, (item) => {
  return routes.indexOf(item.path) == -1;
});

export default filteredMenu;
